i.icon-more{position:relative}i.icon-more.applied:after{content:"";position:absolute;top:0;right:0;width:8px;height:8px;border-radius:50%;background-color:#258cfd;transform:translate(50%,-50%)}i.disabled{opacity:.4}
/*# sourceMappingURL=mnt-actions.component-LLEZMGNG.css.map */
